import { Box, Text } from '@domain-group/suit-theme'

import useOrderBundleItem from '@hooks/useOrderBundleItem'

import type { OrderBundleItemModel } from '@domain-group/realhub-backend-api-types'

interface OrderBundleItemProps {
  orderBundleItem: OrderBundleItemModel,
}

const OrderBundleItem = (props: OrderBundleItemProps) => {
  const { orderBundleItem } = props

  const orderBundleItemPayload = useOrderBundleItem(orderBundleItem)
  const {
    orderBundleItem: {
      quantity,
      options_string,
      title,
    },
    publication,
  } = orderBundleItemPayload

  return (
    <Box lineHeight="1.3">
      <Text fontSize="xsmall" marginTop="medium">
        {publication.title && `${publication.title} - `}
        {quantity} x {title}
      </Text>

      <Text color="bodyFontLightColor" fontSize="xsmall" marginLeft="small" marginTop="medium">
        {options_string}
      </Text>
    </Box>
  )
}

export default OrderBundleItem
